<template>
  <TariffNotificationModal
      ref="modalRef"
      title="Ваш бесплатный доступ ко всем функциям скоро завершится"
      @button-click="onConfirm"
      @hidden="emit('hidden')"
      button-text="Оформить подписку"
      :max-width="450"
  >

    <template #default>
        <p class="trial-expiring-modal__text mb-3">
            После окончания пробного периода: будет доступно только 3 ученика, функции звонков и онлайн-доски станут недоступны
        </p>
        <p class="trial-expiring-modal__text mb-3">
            Если у вас добавлено более 3 учеников и не подключён «Безлимит», ученики сверх лимита будут перемещены в архив.
            <br>
            Все созданные вами доски, станут недоступны но будут сохранены в материалах. 
        </p>
        <p class="trial-expiring-modal__text">
            Выберите удобный набор возможностей и оплачивайте только то, чем пользуетесь.
        </p>
    </template>
  </TariffNotificationModal>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import TariffNotificationModal from '../../TariffNotificationModal.vue';

const modalRef = ref<InstanceType<typeof TariffNotificationModal>>();

function onConfirm() {
    emit('confirm');
    hideModal();
}

const emit = defineEmits<{
    (e: 'hidden'): void;
    (e: 'confirm'): void;
}>();

function showModal() {
    modalRef.value?.show();
}

function hideModal() {
    modalRef.value?.hide();
}

defineExpose({
    show: showModal,
    hide: hideModal,
});

</script>

<style lang="scss" scoped>
// Стили для конкретного тарифного модала (размеры картинки, отступы, кнопка)
.trial-expiring-modal__image {
    width: 267px;
    height: 203px;
    object-fit: cover;
    display: block;

    @media (max-width: 767.98px) {
        width: 165px;
        height: 126px;
        margin: 0 auto 10px; // центрирование + отступ снизу
    }
}

.trial-expiring-modal__text {
    font-size: 14px;
}

.trial-expiring-modal__footer {
    margin-top: 1rem;
    text-align: right;

    @media (max-width: 767.98px) {
        text-align: center;
    }
}
</style>